import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CatalogGate } from "@/context/CatalogGate";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CartDrawer } from "@/components/layout/CartDrawer";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CollectionPage from "@/pages/CollectionPage";
import { PatternsPage, PatternDetailPage } from "@/pages/PatternsPage";
import CatalogoPage from "@/pages/CatalogoPage";
import CartPage from "@/pages/CartPage";
import SharedCartPage from "@/pages/SharedCartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import { OrderCancelledPage, OrderConfirmationPage } from "@/pages/OrderResultPages";
import NotFoundPage from "@/pages/NotFoundPage";
import { AboutPage, ContactPage, FaqPage, LegalPage } from "@/pages/InfoPages";
import { LEGAL_PAGES } from "@/config/site";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

const Layout = () => (
  <>
    <a href="#conteudo" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-ink focus:px-4 focus:py-2 focus:text-ivory">Saltar para o conteúdo</a>
    <Header />
    <main id="conteudo">
      <Outlet />
    </main>
    <Footer />
    <CartDrawer />
  </>
);

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <CatalogGate>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="admin/*" element={<Suspense fallback={null}><AdminApp /></Suspense>} />
            <Route element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="loja" element={<ShopPage />} />
              <Route path="produto/:slug" element={<ProductPage />} />
              <Route path="catalogo" element={<CatalogoPage />} />
              <Route path="tecidos" element={<PatternsPage />} />
              <Route path="tecidos/:id" element={<PatternDetailPage />} />
              <Route path="colecoes/:slug" element={<CollectionPage />} />
              <Route path="sobre" element={<AboutPage />} />
              <Route path="perguntas-frequentes" element={<FaqPage />} />
              <Route path="contactos" element={<ContactPage />} />
              <Route path="carrinho" element={<CartPage />} />
              <Route path="carrinho/partilhado" element={<SharedCartPage />} />
              <Route path="finalizar" element={<CheckoutPage />} />
              <Route path="encomenda/confirmacao" element={<OrderConfirmationPage />} />
              <Route path="encomenda/cancelada" element={<OrderCancelledPage />} />
              {LEGAL_PAGES.map((p) => <Route key={p.slug} path={p.slug} element={<LegalPage slug={p.slug} />} />)}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
          <Toaster position="top-center" toastOptions={{ style: { background: "rgb(var(--bb-ink))", color: "rgb(var(--bb-ivory))", border: "none", borderRadius: "22px", padding: "14px 18px", justifyContent: "center", textAlign: "left" } }} />
        </BrowserRouter>
      </CartProvider>
      </CatalogGate>
    </MotionConfig>
  );
}
